export enum ProgressGPTReplyTypeEnum {
    USER = 'USER',
    BOT = 'BOT',
}
